<template>
  <div class="challenge-view">

    <div class="header-subnav-holder mb-2 pr-0" v-if="shouldShowTabs">
              <div
                class="mt-1"
                v-for="(tab, index) in tabsList"
                :key="tab.id"
              >
                <button
                  type="button"
                  class=" mx-3 pr-1 text-sm font-bold focus:outline-none pb-2"
                  @click="selectedTab = tab.path"
                  v-bind:class="[selectedTab === tab.path ? 'selected' : 'text-gray-500']"
                >
                  {{ tab.name }}
                </button>
                <span v-if="index < tabsList.length - 1" class="opacity-25"
                  >|</span
                >
              </div>
            </div>


    <ChallengeEvent v-if="viewIsEvent"  :pupils="pupils"></ChallengeEvent>
    <ChallengeScoreboard v-else></ChallengeScoreboard>
  </div>
</template>

<script>
const ChallengeEvent = () =>
import("@/components/challenges/TheChallengeEvent.vue");
const ChallengeScoreboard = () =>
import("@/components/challenges/TheChallengeScoreboard.vue");

export default {
  props: {
    pupils: {type: Array, required: true},
    viewType: {type: String, required: true},
  },
  computed: {
    viewIsEvent() {
      return this.selectedTab === 'event'
    },
    tabsList() {
      return this.tabs;
    },
    shouldShowTabs() {
      return this.pupils.length > 0
    }
  },
  data() {
    return {
     selectedTab: this.viewType,
     tabs: []
    };
  },
  mounted() {
    this.tabs = [
      { id: 1, name: "Participate", path: "event" },
      { id: 2, name: "Scoreboard", path: "scoreboard" },
    ];
  },
  methods: {
    
  },
  components: {
    ChallengeEvent,
    ChallengeScoreboard
  }
};
</script>

<style scoped>
.link {
  @apply inline-flex items-center py-2 text-sm font-semibold text-center text-action-blue cursor-pointer;
}

.selected {
  @apply text-blue-500 font-bold border-b border-blue-500;
}
</style>